module.exports = __webpack_public_path__ + "static/img/qcx-a2.0edf58b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qcx-a2.png
// module id = G7ah
// module chunks = 1